import { render, staticRenderFns } from "./upgradeContractView.vue?vue&type=template&id=171009be"
import script from "./upgradeContractView.vue?vue&type=script&lang=js"
export * from "./upgradeContractView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports